import { render, staticRenderFns } from "./AssociateOrgsConfig.vue?vue&type=template&id=124fa853&scoped=true&"
import script from "./AssociateOrgsConfig.vue?vue&type=script&lang=js&"
export * from "./AssociateOrgsConfig.vue?vue&type=script&lang=js&"
import style0 from "./AssociateOrgsConfig.vue?vue&type=style&index=0&id=124fa853&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fa853",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/usage/AssociateOrgsConfig.vue
// module id = 1448
// module chunks = 0